import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import NavAppbar from '../nav-top/NavAppbar';
import PageTitle from '../page-title/PageTitle';
import MyTasksContent from './MyTasksContent';
import { fetchProject, setProject } from '../../features/project/actions';
import { getProjectState } from '../../features/project/selectors';
import { getProjectLoadingState } from '../../features/loading/selectors';
import { setDocumentsType } from '../../features/documents/actions';
import FullscreenLoader from '../loader/FullscreenLoader';
import { ProjectMatchParams } from '../../scripts/utils';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    minHeight: '100vh',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    // Off-white page background so the white table reads as a standard document table.
    backgroundColor: '#FAFAFA',
  },
}));

export default function MyTasksPage() {
  const classes = useStyles();
  const params = useParams<ProjectMatchParams>();
  const dispatch = useDispatch();
  const history = useHistory();
  const project = useSelector(getProjectState);
  const projectLoading = useSelector(getProjectLoadingState);

  useEffect(() => {
    if (params.projectId && params.projectId !== project?.id && !projectLoading) {
      dispatch(fetchProject(params.projectId)).then((action: any) => {
        if (!action?.payload) history.push('/main');
      });
    } else if (!params.projectId) dispatch(setProject());

    dispatch(setDocumentsType(null));
  }, [params, projectLoading]);

  if (projectLoading) return <FullscreenLoader />;

  return (
    <main className={classes.content}>
      <NavAppbar />
      <PageTitle
        title={`My Work - ${project ? project.name : 'All Projects'}`}
        subtitle="Everything requiring your attention, organized by due date"
        fitContent
      />
      <MyTasksContent />
    </main>
  );
}
